export default __webpack_public_path__ + "static/media/figuremap53.b821e54f.png";